import { rem } from "@huub-web/utils/css/rem";
import { style, styleVariants } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { alignVariants } from "../../utils/vanilla/alignVariants";

const baseContainerStyle = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTopLeftRadius: rem(3),
  borderBottomLeftRadius: rem(3),
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  backgroundColor: "var(--background)",
  userSelect: "none",
  ":after": {
    content: "",
    position: "absolute",
    top: "50%",
    right: rem(-6),
    width: 0,
    height: 0,
    borderTop: `${rem(10)} solid transparent`,
    borderBottom: `${rem(10)} solid transparent`,
    borderLeft: `${rem(6)} solid var(--background)`,
    transform: "translateY(-50%)",
  },
});

export const containerSizeStyle = recipe({
  base: {},
  variants: {
    justifySelf: {
      ...alignVariants("justifySelf"),
    },
    size: {
      s: {
        height: rem(20),
        padding: `${theme.spacings.xxs} ${theme.spacings.xxs}`,
        marginRight: theme.spacings.xxs,
      },
      m: {
        height: rem(28),
        padding: `${theme.spacings.xxs} ${theme.spacings.xs}`,
        marginRight: theme.spacings.xs,
        ":after": {
          borderTopWidth: rem(13),
          borderBottomWidth: rem(13),
          borderLeftWidth: rem(8),
          right: rem(-8),
        },
      },
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const containerStyle = styleVariants({
  APlusPlusPlusPlusPlus: [
    baseContainerStyle,
    { vars: { "--background": "#006634" } },
  ],
  APlusPlusPlusPlus: [
    baseContainerStyle,
    { vars: { "--background": "#006634" } },
  ],
  APlusPlusPlus: [baseContainerStyle, { vars: { "--background": "#006634" } }],
  APlusPlus: [baseContainerStyle, { vars: { "--background": "#006634" } }],
  APlus: [baseContainerStyle, { vars: { "--background": "#006634" } }],
  A: [baseContainerStyle, { vars: { "--background": "#006634" } }],
  B: [baseContainerStyle, { vars: { "--background": "#018D37" } }],
  C: [baseContainerStyle, { vars: { "--background": "#92C01F" } }],
  D: [baseContainerStyle, { vars: { "--background": "#FFEB00" } }],
  E: [baseContainerStyle, { vars: { "--background": "#F7B231" } }],
  F: [baseContainerStyle, { vars: { "--background": "#E95A0C" } }],
  G: [baseContainerStyle, { vars: { "--background": "#BC1622" } }],
});

export const textStyle = recipe({
  base: {
    pointerEvents: "none",
    fontWeight: "bold",
  },
  variants: {
    color: {
      light: {
        color: theme.colors.background,
      },
      dark: {
        color: theme.colors.onBackground,
      },
    },
    size: {
      s: {
        fontSize: rem(16),
      },
      m: {
        fontSize: rem(22),
      },
    },
  },
  defaultVariants: {
    color: "light",
    size: "m",
  },
});
